export const SNACKBAR = '[Snackbar]';

export const SET_SNACKBAR = `${SNACKBAR} SET_SNACKBAR`;
export const SET_SIDEBAR_SATE = `${SNACKBAR} SET_SIDEBAR_SATE`;
